"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CollegeHat16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_17831_30981)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 5L8.18162 0.804688L16 5V6L14.0002 6.94967V13.1623L13.4943 13.4498C11.4841 14.5924 9.73032 15.0673 7.93871 14.9921C6.18152 14.9184 4.48318 14.3168 2.60094 13.4973L2.00016 13.2357V6.71875L1.5 6.44922V11H0V5ZM12.0002 7.94967V11.9858C10.4714 12.776 9.22633 13.0444 8.02257 12.9939C6.80698 12.9429 5.55521 12.5651 4.00016 11.9194V7.76821L8.18162 9.85894L12.0002 7.94967ZM3.59951 5.33181L8.18162 7.62287L12.7637 5.33181L8.18162 3.04076L3.59951 5.33181Z", fill: "black" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_17831_30981" },
                react_1.default.createElement("rect", { width: 16, height: 16, fill: "white" }))));
}
function CollegeHat16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CollegeHat16Svg, Object.assign({}, svgProps)));
}
exports.default = CollegeHat16;
//# sourceMappingURL=CollegeHat16.js.map